import React from 'react'
import { PageProps } from '@/types'

interface EmailConfirmationProps extends PageProps {
  survey_set_id: number
}

const EmailConfirmation: React.FC<EmailConfirmationProps> = ({ survey_set_id }) => {
  return (
    <div className="bg-blue-50 h-screen">
      <div className="flex items-center px-4">
        <div className="bg-white rounded-lg shadow-lg p-8 mx-auto text-center max-w-lg w-full my-20">
          <div className="mb-6">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" role="img" aria-label="Confirmación exitosa">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-800">¡Tu información de contacto fue enviada!</h1>
          </div>

          <p className="text-gray-600 mb-8">
            Hemos guardado tu información de contacto. Te mantendremos informado sobre las mejoras de este servicio digital.
          </p>

          <button
            onClick={() => window.location.href = `/encuestas/${survey_set_id}`}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            Finalizar
          </button>
        </div>
      </div>
    </div>
  )
}

export default EmailConfirmation
